var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sans text-gray-900 antialiased"},[_c('div',{staticClass:"pt-4 bg-gray-100"},[_c('div',{staticClass:"min-h-screen flex flex-col items-center pt-6 sm:pt-0"},[_c('div',{staticClass:"w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose"})])])])
}]

export { render, staticRenderFns }